module.exports = __webpack_public_path__ + "img/buzon.a0f963d2.png";